'use strict';

export class ActivateRegistrationCtrl
{
	
	$scope;
	notify;
	jsDataService;
	pageProgress;
	
	progress = false;
	submitted = false;
	completed = false;
	
	recaptchaResponse;
	passwordPolicy = {
		is: false,
		minLength: 0,
		includeUpercase: false,
		includeNumber: false,
		includeSymbol: false,
	};
	
	postData = {
		password: '',
		password_repeat: ''
	};
	
	constructor($scope, jsDataService, notify, pageProgress){
		'ngInject';
		this.$scope = $scope;
		this.notify = notify;
		this.jsDataService = jsDataService;
		this.pageProgress = pageProgress;
		let passwordPolicy = angular.merge({}, this.passwordPolicy, jsDataService.get('cfg.passwordPolicy', {}));
		if(!angular.equals(this.passwordPolicy, passwordPolicy)){
			passwordPolicy.is = true;
			this.passwordPolicy = passwordPolicy;
		}
		if(this.passwordPolicy.minLength < 1){
			this.passwordPolicy.minLength = 1;
		}
	}
	
	submitActivation(e){
		const url = this.jsDataService.get('submitUrl');
		if(url){
			const self = this;
			const rec = self.jsDataService.get('recaptcha');
			if(rec){
				grecaptcha.ready(function() {
					grecaptcha.execute(rec.siteKey, {action: 'submit'}).then(function(token){
						self.recaptchaResponse = token;
						self.submitData(e);
					});
				});
			}
			else{
				self.submitData(e);
			}
			
		}
	}
	
	submitData(e){
		const url = this.jsDataService.get('submitUrl');
		if(url){
			const self = this;
			let dat = this.postData;
			const rec = this.jsDataService.get('recaptcha');
			if(rec){
				dat[rec.field] = this.recaptchaResponse;
			}
			this.$scope.basicHttpConfigProcess({
				url: url,
				method: 'POST',
				responseType: 'json',
				data: dat
			}).then(function(response){
				self.progress = false;
				if(response.data){
					if(response.data.success){
						self.submitted = false;
						self.completed = true;
					}
					else{
						self.submitted = false;
					}
				}
			}, function(response){
				self.progress = false;
				self.submitted = false;
			});
		}
	}
}
	